import {saveAs} from 'file-saver';

interface IDownloadButtonPrpps{
    url: string;
    fileName: string;
}

export const DownloadButton = (props:IDownloadButtonPrpps)=>{


 
    const downloadImage = () => {
        saveAs(props.url, props.fileName) 
      }
    return (
        <>
         <div className="cursor-pointer inline-block bg-orange py-4 px-10 rounded-l-full text-white rounded-r-full shadow border-2"
            
            onClick={downloadImage}
            > Download</div>
        </>
        
    );
}